import { useCallback, useEffect, useState } from 'react';
import { ListNotificationsAPI, MarkNotificationsReadAPI, MarkAllNotificationsReadAPI } from '../../api/API';

const PER_PAGE = 30;

export const FILTERS = [
  { value: 'all', label: 'Todas' },
  { value: 'unread', label: 'Não lidas' },
  { value: 'action', label: 'Providências' },
  { value: 'resolved', label: 'Resolvidas' },
];

/**
 * Página "Notificações": lista paginada do usuário logado, por filtro.
 * O sino do cabeçalho tem o próprio poll (useNotifications); aqui a lista é carregada
 * a cada troca de filtro ou página e ao marcar como lida.
 */
const useNotificationsPage = () => {
  const [filter, setFilterState] = useState('all');
  const [page, setPage] = useState(1);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const load = useCallback(() => {
    setIsLoading(true);
    ListNotificationsAPI(filter, page, PER_PAGE, (response) => {
      setIsLoading(false);
      if (!response || !response.success) return;
      setItems(Array.isArray(response.items) ? response.items : []);
      setTotal(response.total || 0);
    });
  }, [filter, page]);

  useEffect(() => { load(); }, [load]);

  const setFilter = (value) => {
    setFilterState(value);
    setPage(1);
  };

  const markRead = (ids) => {
    const now = new Date().toISOString().slice(0, 19).replace('T', ' ');
    setItems((current) => current.map((item) => (
      ids.includes(item.id) && !item.is_read ? { ...item, is_read: true, read_at: now } : item
    )));
    MarkNotificationsReadAPI(ids, () => {});
  };

  const markAllRead = () => {
    MarkAllNotificationsReadAPI(() => load());
  };

  const pagination = { total, page, limit: PER_PAGE, pages: Math.max(1, Math.ceil(total / PER_PAGE)) };

  return { filter, setFilter, items, pagination, isLoading, setPage, markRead, markAllRead };
};

export default useNotificationsPage;
